import React from 'react'
import { Grid } from "@mui/material";
import {
    ApprovedIcon,
    NotApprovedIcon,
  } from "../../../../_uiComponents/common/DataGridComponents";
import UiMobileInput from '../../../../_uiComponents/common/form/UiMobileInput';

export default function ViewParticipantDetails(props) {

    const {participantDetails} = props

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} lg={6} sx={{ mt: 1 }} className='sba-participant-details'>
                    <span><label>Application</label>
                    <label>{participantDetails?.application}</label>
                    </span>
                </Grid>
                <Grid item xs={12} lg={6} sx={{ mt: 1 }} className='sba-participant-details'>
                    <span><label>Area</label>
                    <label>{participantDetails?.area}</label>
                    </span>
                </Grid>
                <Grid item xs={12} lg={6} sx={{ mt: 1 }} className='sba-participant-details'>
                    <span><label>Dealership</label>
                        {participantDetails?.dealershipCode || participantDetails?.dealershipName ?  <label>{participantDetails?.dealershipCode} | {participantDetails?.dealershipName}</label> : ''}
                    </span>
                </Grid>
                <Grid item xs={12} lg={6} sx={{ mt: 1 }} className='sba-participant-details'>
                    <span><label>Email</label>
                    <label>{participantDetails?.email}</label>
                    </span>
                </Grid>
                {/* <Grid item xs={12} lg={6} sx={{ mt: 1 }} className='sba-participant-details'>
                    <span><label>Mobile</label>
                    <label><UiMobileInput value={participantDetails?.mobile}/></label>
                    </span>
                </Grid> */}
                <Grid item xs={12} lg={6} sx={{ mt: 1 }} className='sba-participant-details'>
                    <span><label>First Name</label>
                    <label>{participantDetails?.firstName}</label>
                    </span>
                </Grid>
                <Grid item xs={12} lg={6} sx={{ mt: 1 }} className='sba-participant-details'>
                    <span><label>Last Name</label>
                    <label>{participantDetails?.lastName}</label>
                    </span>
                </Grid>
                <Grid item xs={12} lg={6} sx={{ mt: 1 }} className='sba-participant-details'>
                    <span><label>Account Activated</label>
                    <label>{participantDetails?.accountActivated ? <ApprovedIcon/> : <NotApprovedIcon/>}</label>
                    </span>
                </Grid>
                <Grid item xs={12} lg={6} sx={{ mt: 1 }} className='sba-participant-details'>
                    <span><label>Status</label>
                    <label>{participantDetails?.active ? <ApprovedIcon/> : <NotApprovedIcon/>}</label>
                    </span>
                </Grid>
              
            </Grid>
           


        </>
    )
}
